import * as React from 'react';

type TdProps = React.DetailedHTMLProps<React.TdHTMLAttributes<HTMLTableDataCellElement>, HTMLTableDataCellElement> & {
	initialIndent?: 'standard' | 'large'
};

export const Td: React.FC<TdProps> = ({ children, ...props }) => {
	const attrs = props || {} as TdProps;
	const classList = ['table__cell'];
	if (attrs.className) {
		classList.push(attrs.className);
	}
	if (attrs.initialIndent) {
		classList.push('table__cell-large-indent');
	}
	return <td {...attrs} className={classList.join(' ')}>{children}</td>;
};
